<template>

<div v-if='isReady' class="row">
    <div v-if='notifs.length' class="col-12" v-for='(n,i) in notifs'>
        <!-- <div :class="['alert', n.css_class ? n.css_class : 'alert-info', { seen : n.seen == 1 }]"> -->
        <div :class="['notification alert', n.seen == 0 ? 'alert-success' : 'alert-info' ]">

            <h4 class="notif-name">
                <span :class='["icon", n.icon]'></span> {{ n.title }}
            </h4>

            <a v-if='n.url' :href='n.url || "#"' v-html='n.content'>
                {{ n.content }} 
            </a>
            <span v-else v-html='n.content'></span>

            <div class="d-flex align-items-center justify-content-between mt-3">
                <div class="d-flex align-items-center">
                    <a v-if='n.url' :href="n.url" class="btn btn-primary btn-sm">
                        View here
                    </a>
                    
                    <span @click='removeNotif(n,i)' class="ml-3 pointer"> 
                        Delete 
                    </span>
                </div>

                <div class="date">
                    {{ n.created_at }}
                    <!-- <p>{{ toDate(n.created_at) }}</p> -->
                </div>
            </div>  

        </div>
    </div>

    <div class='col-12'>
        <paginator v-if='isReady && total > perPage'
                   :total='total'
                   v-on:page-change='changePage'
                   :perPage='perPage'>
        </paginator>
    </div>

    <div class='col-12' v-if='isReady && !notifs.length'>
        <div class="alert alert-info">
            <div class="alert-icon">
                <span class="icon icon-poker-face"></span>
            </div>
            <div class="d-flex justify-content-between align-items-center w-100">
                <div>
                    <span class="text-bold d-block">Sorry!</span>
                    <span class="text-small">You dont have any notifications.</span>
                </div>
            </div>
        </div>
    </div>
</div>
 
</template>

<script>
    export default {
        mounted() {
            this.getData();
        },

        created() {
        },

        data() {
            var me = this;

            return {

                total   : 0,
                perPage : 10,
                page    : 1,
                isReady : false,
                notifs  : []
            
            }
        },

        methods : {

            getData() { 

                var me = this,
                    data = { pp : this.perPage, p : this.page };

                //First pull, get count
                if( !this.isReady ) {
                    data.init = 1;
                }

                me.ajax.call('usr:gnt', data, (r) => {
                    if( r.status == 'success' ) {
                        me.notifs = r.data.notifs;

                        var numSeen = 0;

                        for(var i in r.data.notifs ) {
                            if( r.data.notifs[i].seen == 0 ){
                                numSeen++;
                            }
                        }

                        me.$store.state.newNotifs -= numSeen;
                        if( me.$store.state.newNotifs < 0 ){
                            me.$store.state.newNotifs = 0;
                        }

                        if( !me.isReady ) {

                            me.total = r.data.c;
                            me.isReady = true;
                        
                        }
                    }
                })

            },

            removeNotif( n, i ) {
                var me = this;

                me.ajax.call('usr:rmn', { n : n.id }, (r) => {
                    
                    if( r.status == 'success' ) {
                        me.notifs.splice(i,1);
                        $.notify("Notification removed","success");
                    }

                })
            },

            changePage( p ) {
                this.page = p;

                this.getData();

            }

        }

    }
</script>
